// const baseUrl = process.env.REACT_APP_BASE_URL
const baseUrl = "./admin";

export const getNotificationBannner = () => baseUrl + "/bannermessage";
export const getPlannedMaintenance = () => baseUrl + "/plannedmaintenance";
